export enum NotificationStatusType {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  ERROR = 'error',
  PRIMARY = 'primary',
}
